import { RestSlice } from '../../../../../redux/rest.slice';
import { IppDataSourceCtsEventType } from '@rcp/types';
import { Resource, localizationService } from 'src/services';

export const ippCtsEventTypeSlice = new RestSlice<IppDataSourceCtsEventType>(
	localizationService.getLocalizedString('ipp.industryAccount.dataProviders.translations.sampleTypes.heading'),
	Resource.IppDataSourceCtsEventTypes
);
export default ippCtsEventTypeSlice.rests.reducer;
